export default "__VITE_ASSET__DKwYRcXs__"